import wretch from 'wretch';

interface ApiUrlBuilderOptions {
    kind?: 'rest';
    storeCode?: string;
    version?: 'V1';
    serviceUrl?: string;
}

interface ApiUrlBuilderParams {
    [key: string]: string;
}

export const apiUrlBuilder = (
    endpoint: string,
    params: ApiUrlBuilderParams = {},
    {
        kind = 'rest',
        storeCode = 'all',
        version = 'V1',
        serviceUrl = ':kind/:storeCode/:version',
    }: ApiUrlBuilderOptions = {}
) => {
    const url = `${serviceUrl}${endpoint}`;
    const parts = url.split('/');
    params = {
        ...params,
        kind,
        storeCode,
        version,
    };
    for (let index = 0; index < parts.length; index++) {
        const part = parts[index].replace(':', '');
        if (typeof params[part] === 'undefined') {
            continue;
        }
        parts[index] = params[part];
    }

    return `/${parts.join('/')}`;
};

export const api = wretch()
    .options({
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
    .errorType('json');
